/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy } from '@angular/core';
import { dateCache } from '@touchplan/common';

const serviceTerms = 'https://www.touchplan.io/terms-of-service#terms-of-service';

@Component({
	// tslint:disable-next-line: component-selector
	selector: 'legalese',
	template: ` <div class="footer-links">
		<div class="terms-of-service">
			<a href="${serviceTerms}">Terms of Service</a>
		</div>
		<div class="credits">
			© {{ dateCacheThing.today.format('YYYY') }} MOCA Systems, Inc.
			<br />
			All rights reserved
			<br />
			Produced under U.S. Pat. 10,410,178 B2
		</div>
	</div>`,
	styleUrls: ['./legalese.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegaleseComponent {
	public dateCacheThing = dateCache;
}
